import React from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";

const PaymentFailed = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentData = location.state?.paymentData || null;
  const errorMessage = location.state?.errorMessage || null;

  const invoiceid =
    searchParams.get('invoiceid') ||
    paymentData?.invoiceid ||
    searchParams.get('invoiceno') ||
    paymentData?.invoiceno;
  const orderno =
    searchParams.get('orderno') ||
    paymentData?.orderno ||
    paymentData?.orderNo;

  const statusString = paymentData?.status?.toLowerCase() || "";
  const statusId = paymentData?.statusid;

  const isCancelled = statusString.includes('cancel') || statusId === 7;
  const isExpired = statusString.includes('expire') || statusId === 6;

  let headingText = "Payment Failed";
  let statusBadgeText = "Failed";
  let badgeClass = "bg-danger text-danger";
  let messageText = errorMessage || 'Your payment could not be processed. Please try again.';

  if (isCancelled) {
    headingText = "Payment Cancelled";
    statusBadgeText = "Cancelled";
    messageText = errorMessage || 'You have cancelled the payment process.';
  } else if (isExpired) {
    headingText = "Payment Expired";
    statusBadgeText = "Expired";
    messageText = errorMessage || 'Your payment session has expired. Please try again.';
  }

  const handleRetry = () => navigate("/deposit");

  return (
    <>
      <div id="layout-wrapper">
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                <div className="col-xl-5 col-lg-6 col-md-8">
                  <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                    <div className="card-body p-5 text-center">
                      <div className="mb-4">
                        <div
                          className="d-inline-flex align-items-center justify-content-center bg-danger bg-opacity-10 text-danger rounded-circle"
                          style={{ width: '80px', height: '80px' }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 38 38" fill="none">
                            <circle cx="19" cy="19" r="17.8" stroke="currentColor" strokeWidth="2.4" />
                            <line x1="12" y1="12" x2="26" y2="26" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                            <line x1="26" y1="12" x2="12" y2="26" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                          </svg>
                        </div>
                      </div>

                      <h2 className="fw-bold mb-3">{headingText}</h2>
                      <p className="text-muted mb-4 fs-5">{messageText}</p>

                      <div className="rounded-3 p-3 mb-4 text-start border">
                        {invoiceid && (
                          <div className="d-flex flex-column flex-sm-row justify-content-between border-bottom pb-3 mb-3 gap-1 gap-sm-3">
                            <span className="text-muted fw-semibold text-nowrap">Order No</span>
                            <span className="fw-bold text-sm-end" style={{ wordBreak: 'break-all' }}>{invoiceid}</span>
                          </div>
                        )}
                        {(!orderno && !invoiceid && paymentData?.paymentId) && (
                          <div className="d-flex flex-column flex-sm-row justify-content-between border-bottom pb-3 mb-3 gap-1 gap-sm-3">
                            <span className="text-muted fw-semibold text-nowrap">Transaction ID</span>
                            <span className="text-white fw-bold text-sm-end" style={{ wordBreak: 'break-all' }}>{paymentData.paymentId}</span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between">
                          <span className="text-muted fw-semibold">Status</span>
                          <span className={`badge ${badgeClass} bg-opacity-10 fw-bold px-3 py-2 rounded-pill`}>{statusBadgeText}</span>
                        </div>
                      </div>

                      <div className="d-grid gap-3">
                        <button className="btn btn-primary btn-lg rounded-3 fw-bold" onClick={handleRetry}>
                          <i className="bx bx-left-arrow-alt me-2"></i> Back to Deposit
                        </button>
                        <button className="btn btn-outline-primary btn-lg rounded-3 fw-bold" onClick={() => navigate('/dashboard')}>
                          <i className="bx bx-home-alt me-2"></i> Go to Dashboard
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default PaymentFailed;
